import * as React from "react";
import { SVGProps } from "react";

export const PasswordSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.194" height="10" viewBox="0 0 16.194 10" {...props}>
        <g id="Group_8478" data-name="Group 8478" transform="translate(637.324 -1179.866)">
            <path
                id="Path_255"
                data-name="Path 255"
                d="M-625.858,1182.143a.451.451,0,0,1,0,.586c-.851,1-3.865,4.207-7.453,4.207s-6.6-3.209-7.453-4.207a.451.451,0,0,1,0-.586c.851-1,3.865-4.207,7.453-4.207S-626.709,1181.145-625.858,1182.143Z"
                transform="translate(4.084 2.43)"
                fill="none"
                stroke="#333"
                strokeLinecap="round"
                strokeWidth="1"
            />
            <path
                id="Path_268"
                data-name="Path 268"
                d="M2.375,0A2.375,2.375,0,1,1,0,2.375,2.375,2.375,0,0,1,2.375,0Z"
                transform="translate(-631.602 1182.491)"
                fill="#333"
                stroke="#333"
                strokeWidth="1"
            />
        </g>
    </svg>
);
